import { Component, OnInit, ViewChild } from '@angular/core';

import { CBMError, FcdVersion, Task } from 'app/models';
import { FcdMapVersionStatusType, TaskType } from 'app/models/enums';
import { FcdProviderService, TaskService } from 'app/services';
import { DialogImportFcdComponent } from 'app/shared/dialog-import-fcd/dialog-import-fcd.component';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'import-osm-nwb-fcd',
  templateUrl: './import-fcd.component.html',
  styleUrls: ['./import-fcd.component.scss']
})
export class ImportFcdComponent implements OnInit {
  @ViewChild('dialogImportFcdComponent') dialogImportFcdComponent: DialogImportFcdComponent;

  public fcdVersions: FcdVersion[] = [];
  public fcdVersionBlobNames: string[] = [];

  public fcdTask: Task;

  public errorMessages: CBMError[];

  public fcdMapVersionStatusType: FcdMapVersionStatusType;
  public fcdMapVersionStatusTypes: string[];

  public fcdVersionInput: string;

  constructor(private readonly taskService: TaskService, private readonly fcdProviderService: FcdProviderService) {}

  ngOnInit(): void {
    this.fcdMapVersionStatusTypes = enumValues(FcdMapVersionStatusType);

    this.getDownloadOptions();
    this.getTaskStatus(TaskType.FcdImportTask);
  }

  private getDownloadOptions(): void {
    this.fcdProviderService.getFcdVersions().subscribe(
      result => {
        this.fcdVersions = result;
        this.fcdVersionBlobNames = result.map(v => this.formatFcdVersionForDropDown(v));
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  private getTaskStatus(taskType: string): void {
    this.taskService.getTaskByType(taskType).subscribe(result => {
      this.fcdTask = result;
    });
  }

  public checkFcdVersion(fcdVersion: FcdVersion): void {
    this.fcdProviderService.checkMapVersion(fcdVersion).subscribe(
      (response: Response) => {
        if (response.status === 200) {
          this.fcdMapVersionStatusType = FcdMapVersionStatusType.NEWER;
          this.assertMapVersionStatusType();
        }
      },
      (error: CBMError[]) => {
        if (error[0].code === '409') {
          this.fcdMapVersionStatusType = FcdMapVersionStatusType.EQUAL;
          this.assertMapVersionStatusType();
        } else {
          this.fcdMapVersionStatusType = FcdMapVersionStatusType.OLDER;
          this.assertMapVersionStatusType();
        }
      }
    );
  }

  public startFcdImport(): void {
    this.errorMessages = [];

    const selectedVersion = this.fcdVersions.find(v => this.formatFcdVersionForDropDown(v) === this.fcdVersionInput);
    this.taskService.startFcdImportTaskFromBlob(selectedVersion.mapId).subscribe(
      () => this.getTaskStatus(TaskType.FcdImportTask),
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  public prepareStartFcdImport() {
    const selectedVersion = this.fcdVersions.find(v => this.formatFcdVersionForDropDown(v) === this.fcdVersionInput);
    this.checkFcdVersion(selectedVersion);
  }

  private assertMapVersionStatusType() {
    this.dialogImportFcdComponent.show(this.fcdMapVersionStatusType);
  }

  private formatFcdVersionForDropDown(v: FcdVersion) {
    return `${v.mapId} || ${v.retrieveDate}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/import/fcd/import-fcd.component.ts